import { render, staticRenderFns } from "./BaseGroupStatus.vue?vue&type=template&id=4106789f"
import script from "./BaseGroupStatus.vue?vue&type=script&lang=js"
export * from "./BaseGroupStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4106789f')) {
      api.createRecord('4106789f', component.options)
    } else {
      api.reload('4106789f', component.options)
    }
    module.hot.accept("./BaseGroupStatus.vue?vue&type=template&id=4106789f", function () {
      api.rerender('4106789f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/BaseGroupStatus.vue"
export default component.exports